'use client';
import { ListboxOptionThumbnailContainer } from '../listbox/listbox-option-thumbnail-container.component.js';

const ComboboxOptionThumbnailContainer = ListboxOptionThumbnailContainer;

export { ComboboxOptionThumbnailContainer };
